import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer, { AuthState } from "./auth/auth.reducer";
import { CommitmentState } from "./commitment/commitment.reducer";
import dealReducer, { DealState } from "./deal/deal.reducer";
import investorReducer, { InvestorState } from "./investor/investor.reducer";
import commitmentReducer from "@state/commitment/commitment.reducer";
import entityReducer, { EntityState } from "./entity/entity.reducer";
import notificationReducer, {
  NotificationState,
} from "./notification/notification.reducer";
import remoteConfig, {
  TRemoteConfigState,
} from "./remoteConfiguration/remoteConfiguration.reducer";
import bankAccountReducer from "./bankAccount/bankAccount.reducer";
import { BankAccountState } from "./bankAccount/bankAccount.types";
import paymentReducer, { PaymentState } from "./payment/payment.reducer";
import documentReducer, { DocumentState } from "./document/document.reducer";
import { plaidReducer } from "./plaid/plaid.reducer";
import { PlaidState } from "./plaid/plaid.types";
import { ifIsaReducer, IfIsaState } from "./ifIsa";
import { eisFundReducer, EisFundState } from "./eisFund";
import fundRestructureReducer, {
  FundRestructureChoiceState,
} from "./fundRestructure/fundRestructure.reducer";
import investmentUpdateReducer, {
  InvestmentUpdateState,
} from "./investmentUpdate/investmentUpdate.reducer";
import uiPreferencesReducer, {
  UiPreferencesState,
} from "./uiPreferences/uiPreferences.reducer";
import onboardingV2Reducer, {
  OnboardingV2State,
} from "./onboardingV2/onboardingV2.reducer";
import dealAnchoredProgressReducer, {
  DealAnchoredProgressState,
} from "./dealAnchoredProgress/dealAnchoredProgress.reducer";
import { dealCapacityReducer, DealCapacityState } from "./dealCapacity";
import viewAsReducer, { ViewAsState } from "./viewAs/viewAs.reducer";

export type RootState = {
  auth: AuthState;
  commitment: CommitmentState;
  deal: DealState;
  entity: EntityState;
  investor: InvestorState;
  notification: NotificationState;
  remoteConfig: TRemoteConfigState;
  bankAccount: BankAccountState;
  payment: PaymentState;
  document: DocumentState;
  plaid: PlaidState;
  ifIsa: IfIsaState;
  eisFund: EisFundState;
  fundRestructure: FundRestructureChoiceState;
  investmentUpdate: InvestmentUpdateState;
  uiPreferences: UiPreferencesState;
  onboardingV2: OnboardingV2State;
  dealAnchoredProgress: DealAnchoredProgressState;
  dealCapacity: DealCapacityState;
  viewAs: ViewAsState;
};

// TODO: Get rid of this persistor without break the build -> TR-232
const persistConfig = {
  key: "root",
  storage,
  // For now, I'm configuring it to persist nothing
  whitelist: [],
  version: 3,
};

const rootReducer = combineReducers<RootState>({
  auth: authReducer,
  commitment: commitmentReducer,
  deal: dealReducer,
  entity: entityReducer,
  investor: investorReducer,
  notification: notificationReducer,
  remoteConfig: remoteConfig,
  bankAccount: bankAccountReducer,
  payment: paymentReducer,
  document: documentReducer,
  plaid: plaidReducer,
  ifIsa: ifIsaReducer,
  eisFund: eisFundReducer,
  fundRestructure: fundRestructureReducer,
  investmentUpdate: investmentUpdateReducer,
  uiPreferences: uiPreferencesReducer,
  onboardingV2: onboardingV2Reducer,
  dealAnchoredProgress: dealAnchoredProgressReducer,
  dealCapacity: dealCapacityReducer,
  viewAs: viewAsReducer,
});

export default persistReducer(persistConfig, rootReducer);
